
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "CTOFACSIC",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/CTOFACSIC.vue